import { useState } from 'react';
import { ReactComponent as AddIcon } from '$icons/Add.svg';
import { ReactComponent as RightArrow } from '$icons/ArrowRight.svg';
import Button from '$components/Buttons/Button';
import ModalInTailwind from '$components/ModalInTailwind/ModalInTailwind';
import { successHandler } from '$store/utils';
import { useGenerateAiDataMutation } from '$store/modules/candidate-ai';

type GenerateScoresProps = {
  selectedCandidates: string[];
};

const GenerateScores = ({ selectedCandidates }: GenerateScoresProps) => {
  const [openGenerateScoreModal, setOpenGenerateScoreModal] = useState(false);
  const [showGenerateAiDataResults, setShowGenerateAiDataResults] =
    useState(false);

  const [generateAiData, { data, isLoading }] = useGenerateAiDataMutation();

  const requestGenerateScoresHandler = () => {
    generateAiData({
      candidateIds: selectedCandidates.map((item) => Number(item)),
    }).then((response) => {
      if (!('error' in response)) {
        successHandler('Request to Generate Scores has been sent', true);
        setShowGenerateAiDataResults(true);
      }
    });
  };

  const handleClose = () => {
    setShowGenerateAiDataResults(false);
    setOpenGenerateScoreModal(false);
  };

  return (
    <>
      <Button
        bgColor="#006789"
        showText
        text="Generate Scores"
        icon={AddIcon}
        invertTextContent
        styling="px-4"
        onClick={() => {
          setOpenGenerateScoreModal((prev) => !prev);
        }}
        disabled={selectedCandidates.length === 0}
      />
      <ModalInTailwind isOpen={openGenerateScoreModal} closeModal={handleClose}>
        <div className="bg-white rounded p-8">
          <div
            className={`flex flex-col ${showGenerateAiDataResults && 'hidden'}`}
          >
            <h1 className="font-bold text-xl mb-4">
              Are you sure you want to generate scores for these candidates?
            </h1>
            <span>
              This will take time depending on the number candidates selected.
            </span>
            <div className="flex flex-row mt-4 self-end w-60">
              <Button
                text="Cancel"
                showText
                textStyles={{ color: '#079e88' }}
                onClick={handleClose}
              />
              <Button
                text={isLoading ? 'Loading' : 'Generate'}
                invertTextContent
                showText
                disabled={isLoading}
                bgColor={isLoading ? '#aaa' : '#079e88'}
                onClick={requestGenerateScoresHandler}
                {...(!isLoading && { icon: RightArrow })}
              />
            </div>
          </div>
          <div
            className={`hidden flex-col ${
              showGenerateAiDataResults && '!flex'
            }`}
          >
            <h1 className="text-xl font-bold">Request Results</h1>
            <div className="max-h-96">
              <div className="grid w-full grid-cols-2 gap-2">
                <div className="font-bold">Candidate Id</div>
                <div className="font-bold">Result</div>
                {data &&
                  Object.keys(data).map((singleResult) => {
                    return (
                      <>
                        <div>{singleResult}</div>
                        <div
                          className={`${
                            data[singleResult].toLowerCase() !== 'success'
                              ? 'text-red-600'
                              : 'text-green-600'
                          }`}
                        >
                          {data[singleResult]}
                        </div>
                      </>
                    );
                  })}
              </div>
            </div>
            <div className="flex flex-row mt-4 self-end w-32">
              <Button
                text="Close"
                showText
                bgColor="#079e88"
                onClick={handleClose}
              />
            </div>
          </div>
        </div>
      </ModalInTailwind>
    </>
  );
};

export default GenerateScores;
